// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__+Vey2","heading":"ErrorBoundary_heading__rbObV","text":"ErrorBoundary_text__PauoU","button":"ErrorBoundary_button__Z716G"};